Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setNativeProps = void 0;
var _PlatformChecker = require("./PlatformChecker");
var _jsReanimated = require("./js-reanimated");
var _Colors = require("./Colors");
var IS_NATIVE = !(0, _PlatformChecker.shouldBeUseWeb)();
var setNativeProps;
var _worklet_15616589191193_init_data = {
    code: "function anonymous(animatedRef,updates){const{processColorsInProps}=this.__closure;if(!_WORKLET){console.warn('[Reanimated] setNativeProps() can only be used on the UI runtime.');return;}const shadowNodeWrapper=animatedRef();processColorsInProps(updates);_updatePropsFabric([{shadowNodeWrapper:shadowNodeWrapper,updates:updates}]);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/SetNativeProps.ts",
    sourceMap: '{"version":3,"names":["anonymous","animatedRef","updates","processColorsInProps","__closure","_WORKLET","console","warn","shadowNodeWrapper","_updatePropsFabric"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/SetNativeProps.ts"],"mappings":"AA0BmB,QAAC,CAAAA,UAAAC,WAAa,CAAOC,OAAK,QAAAC,oBAAA,OAAAC,SAAA,CAEzC,GAAI,CAACC,QAAQ,CAAE,CACbC,OAAO,CAACC,IAAI,CACV,mEACF,CAAC,CACD,OACF,CACA,KAAM,CAAAC,iBAAiB,CAAIP,WAAW,CAAS,CAAsB,CACrEE,oBAAoB,CAACD,OAAO,CAAC,CAE7BO,kBAAkB,CAAE,CAAC,CAAED,iBAAiB,CAAjBA,iBAAiB,CAAEN,OAAA,CAAAA,OAAQ,CAAC,CAAC,CAAC,CACvD"}',
    version: "3.5.4"
};
var _worklet_14681970098344_init_data = {
    code: "function anonymous(animatedRef,updates){const{processColorsInProps}=this.__closure;if(!_WORKLET){console.warn('[Reanimated] setNativeProps() can only be used on the UI runtime.');return;}const tag=animatedRef();const name=animatedRef.viewName.value;processColorsInProps(updates);_updatePropsPaper([{tag:tag,name:name,updates:updates}]);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/SetNativeProps.ts",
    sourceMap: '{"version":3,"names":["anonymous","animatedRef","updates","processColorsInProps","__closure","_WORKLET","console","warn","tag","name","viewName","value","_updatePropsPaper"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/SetNativeProps.ts"],"mappings":"AAwCmB,QAAC,CAAAA,UAAAC,WAAa,CAAOC,OAAK,QAAAC,oBAAA,OAAAC,SAAA,CAEzC,GAAI,CAACC,QAAQ,CAAE,CACbC,OAAO,CAACC,IAAI,CACV,mEACF,CAAC,CACD,OACF,CACA,KAAM,CAAAC,GAAG,CAAIP,WAAW,CAAS,CAAW,CAC5C,KAAM,CAAAQ,IAAI,CAAIR,WAAW,CAASS,QAAQ,CAACC,KAAK,CAChDR,oBAAoB,CAACD,OAAO,CAAC,CAE7BU,iBAAiB,CAAE,CAAC,CAAEJ,GAAG,CAAHA,GAAG,CAAEC,IAAI,CAAJA,IAAI,CAAEP,OAAA,CAAAA,OAAQ,CAAC,CAAC,CAAC,CAC9C"}',
    version: "3.5.4"
};
if ((0, _PlatformChecker.isWeb)()) {
    exports.setNativeProps = setNativeProps = function setNativeProps(_animatedRef, _updates) {
        var component = _animatedRef();
        (0, _jsReanimated._updatePropsJS)(_updates, {
            _component: component
        });
    };
} else if (IS_NATIVE && global._IS_FABRIC) {
    exports.setNativeProps = setNativeProps = function() {
        var _e = [
            new global.Error(),
            -2,
            -27
        ];
        var anonymous = function anonymous(animatedRef, updates) {
            if (!_WORKLET) {
                console.warn("[Reanimated] setNativeProps() can only be used on the UI runtime.");
                return;
            }
            var shadowNodeWrapper = animatedRef();
            (0, _Colors.processColorsInProps)(updates);
            _updatePropsFabric([
                {
                    shadowNodeWrapper: shadowNodeWrapper,
                    updates: updates
                }
            ]);
        };
        anonymous.__closure = {
            processColorsInProps: _Colors.processColorsInProps
        };
        anonymous.__initData = _worklet_15616589191193_init_data;
        anonymous.__workletHash = 15616589191193;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
} else if (IS_NATIVE) {
    exports.setNativeProps = setNativeProps = function() {
        var _e = [
            new global.Error(),
            -2,
            -27
        ];
        var anonymous = function anonymous(animatedRef, updates) {
            if (!_WORKLET) {
                console.warn("[Reanimated] setNativeProps() can only be used on the UI runtime.");
                return;
            }
            var tag = animatedRef();
            var name = animatedRef.viewName.value;
            (0, _Colors.processColorsInProps)(updates);
            _updatePropsPaper([
                {
                    tag: tag,
                    name: name,
                    updates: updates
                }
            ]);
        };
        anonymous.__closure = {
            processColorsInProps: _Colors.processColorsInProps
        };
        anonymous.__initData = _worklet_14681970098344_init_data;
        anonymous.__workletHash = 14681970098344;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
} else if ((0, _PlatformChecker.isChromeDebugger)()) {
    exports.setNativeProps = setNativeProps = function setNativeProps() {
        console.warn("[Reanimated] setNativeProps() is not supported with Chrome Debugger.");
    };
} else if ((0, _PlatformChecker.isJest)()) {
    exports.setNativeProps = setNativeProps = function setNativeProps() {
        console.warn("[Reanimated] setNativeProps() is not supported with Jest.");
    };
} else {
    exports.setNativeProps = setNativeProps = function setNativeProps() {
        console.warn("[Reanimated] setNativeProps() is not supported on this configuration.");
    };
}
